import { getFragmentData, type FragmentType } from '@packages/gql/generated/shopping';
import { RatingPortionFragmentFragmentDoc } from '@packages/gql/generated/shopping/RatingPortionFragmentFragmentDoc';
import { Box } from '@packages/shared';

type RatingPortionMUIProps = {
  data: FragmentType<typeof RatingPortionFragmentFragmentDoc>;
};

export const RatingPortionMUI = ({ data }: RatingPortionMUIProps) => {
  const { portion } = getFragmentData(RatingPortionFragmentFragmentDoc, data);

  return (
    <Box
      component="figure"
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={portion}
      sx={{ backgroundColor: 'info.light', flex: 1, overflow: 'hidden', borderRadius: '3px' }}
    >
      <Box
        component="div"
        sx={{ height: '20px', width: `${portion}%`, backgroundColor: 'info.main' }}
      />
    </Box>
  );
};
